import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import Pagination from '../pagination';
import { InstallmentAction } from '../../store/actions';

class List extends PureComponent {
  static propTypes = {
    authHasOffice: PropTypes.bool,
    getInstallments: PropTypes.func,
    installments: PropTypes.object,
    location: PropTypes.object,
    permissions: PropTypes.arrayOf(PropTypes.string),
  };

  componentDidMount() {
    this.props.getInstallments(
      Object.fromEntries(new URLSearchParams(this.props.location.search)),
    );
  }

  onSearch(event) {
    const {
      target: { value },
    } = event;
    this.props.getInstallments({ query: value });
  }

  render() {
    const {
      authHasOffice = false,
      getInstallments = () => {},
      installments: { data: installments = [], links = [] } = {},
      location = {},
      permissions = [],
    } = this.props;
    return (
      <div className="row">
        <div className="col">
          <div className="card">
            <div className="card-header">
              <h3 className="card-title">Installment</h3>
              <div className="card-tools d-print-none">
                <Pagination
                  getList={getInstallments}
                  links={links}
                  location={location}
                />
              </div>
              <div className="card-tools d-print-none mr-2">
                <div
                  className="input-group input-group-sm"
                  style={{ width: '150px' }}
                >
                  <input
                    className="form-control"
                    onChange={this.onSearch.bind(this)}
                    placeholder="Search"
                    type="text"
                  />
                </div>
              </div>
            </div>
            <div className="card-body p-0 table-responsive">
              {installments?.length === 0 && (
                <p className="text-center my-2">No data found.</p>
              )}
              {installments?.length > 0 && (
                <table className="table table-striped text-nowrap">
                  <thead>
                    <tr>
                      {permissions?.some?.(p =>
                        ['sale.receive', 'sale.view']?.includes?.(p),
                      ) && (
                        <th
                          className="d-print-none"
                          style={{ minWidth: '200px' }}
                        >
                          Action
                        </th>
                      )}
                      {!authHasOffice && <th>Office</th>}
                      <th>Sale ID</th>
                      <th>Customer Name</th>
                      <th>Customer Mobile</th>
                      <th>Installment Date</th>
                      <th>Installment Amount</th>
                      <th>Customer Address</th>
                    </tr>
                  </thead>
                  <tbody>
                    {installments?.map?.(row => (
                      <tr key={row.sale_id}>
                        {permissions?.some?.(p =>
                          ['sale.receive', 'sale.view']?.includes?.(p),
                        ) && (
                          <td className="d-print-none">
                            <div className="btn-group">
                              {permissions?.includes?.('sale.view') && (
                                <Link
                                  className="btn btn-primary btn-sm"
                                  to={`/a/sale/${row.sale_id}/detail`}
                                >
                                  <i className="fas fa-info mr-1"></i>
                                  Detail
                                </Link>
                              )}
                              {permissions?.includes?.('sale.receive') && (
                                <Link
                                  className="btn btn-warning btn-sm"
                                  to={`/a/sale/${row.sale_id}/receive`}
                                >
                                  <i className="fas fa-money-bill mr-1"></i>
                                  Receive
                                </Link>
                              )}
                            </div>
                          </td>
                        )}
                        {!authHasOffice && <td>{row.office_name}</td>}
                        <td>{row.sale_id}</td>
                        <td>{row.customer_name}</td>
                        <td>{row.customer_mobile}</td>
                        <td>{row.installment_at}</td>
                        <td>{row.installment_amount}</td>
                        <td>{row.customer_address}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  authHasOffice: !!state?.auth?.office,
  installments: state?.installment?.list,
  permissions: state?.auth?.permissions,
});

const mapDispatchToProps = dispatch => ({
  getInstallments: params =>
    dispatch(InstallmentAction.getInstallments(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(List);
